export const ActionTypes = {
  SET_ORDERS: 'SET_ORDERS',
  SET_ORDER: 'SET_ORDER',
  SET_ORDER_ROUTES: 'SET_ORDER_ROUTES',
  SET_ORDER_WITH_PARKING_PICTURE_TO_CHECK: 'SET_ORDER_WITH_PARKING_PICTURE_TO_CHECK'
};
